// extracted by mini-css-extract-plugin
export default {"cardbodyitems":"SidebarAccorditionPujas_cardbodyitems__STb-e"};